import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function ReadyForTransformation() {
  return <section data-section-id="229395" id="start-your-session" className="bg-background text-foreground py-32 md:py-48 px-6 flex flex-col items-center justify-center text-center relative overflow-hidden">
      <div className="max-w-5xl mx-auto flex flex-col items-center relative z-10">
        <div className="mb-8 w-16 h-16 rounded-full bg-destructive flex items-center justify-center shadow-[0_0_30px_rgba(239,68,68,0.6)] animate-pulse">
          <div className="w-6 h-6 rounded-full bg-white" />
        </div>
        
        <h2 className="text-5xl md:text-7xl lg:text-8xl font-default font-bold tracking-tighter mb-12 leading-[1.1] uppercase">
          Ready to Capture Your Best Work?
        </h2>
        
        <Button asChild size="lg" className="h-14 px-10 text-lg rounded-full bg-primary text-primary-foreground hover:bg-primary/90 transition-all shadow-[0_0_20px_rgba(0,255,255,0.4)] hover:scale-105">
          <Link to="/ContactPage">
            Inquire Now
          </Link>
        </Button>

        <div className="mt-24 flex flex-wrap justify-center items-center gap-8 md:gap-16 opacity-40 grayscale">
          
          
          
          
        </div>
      </div>
      
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80vw] h-[80vw] max-w-[800px] max-h-[800px] bg-primary/10 rounded-full blur-[120px] pointer-events-none" aria-hidden="true" />
    </section>;
}